export default __webpack_public_path__ + "static/media/bookings_from.c085d3d1.png";